var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-pop-up"},[_c('div',{staticClass:"navigation"},[_c('i',{staticClass:"fas fa-arrow-left back-arrow",on:{"click":_vm.goBack}}),_c('div',{staticClass:"close-button",on:{"click":_vm.closePopup}},[_vm._v("✖")])]),_c('div',{staticClass:"divMeeting"},[_c('meetingComponent')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }